export default __webpack_public_path__ + "static/media/78@2x-8.89541567.png";